class XAiOExperience {
  rootRef = { current: null };
  trackRef = { current: null };
  hostRef = { current: null };

  KF = [
    { ry: -0.5,  rx: 0.06, z: 6.2, y: -0.05, tx: 0,     x: 0,    glow: 0.3, disp: 0.25, press: 0, xr: 0 },
    { ry: -0.38, rx: 0.06, z: 4.2, y: -0.1,  tx: -0.14, x: 0.12, glow: 0,   disp: 0.2,  press: 0, xr: 1 },
    { ry: -1.45, rx: 0.04, z: 3.0, y: -0.4,  tx: 0,     x: -0.2, glow: 0.3, disp: 1,    press: 0, xr: 0 },
    { ry: -1.2,  rx: 0.05, z: 2.3, y: 0.02,  tx: 0.12,  x: 0.2,  glow: 0.3, disp: 1,    press: 1, xr: 0 },
    { ry: -0.8,  rx: 0.1,  z: 5.0, y: 0.45, tx: -0.05, x: 0.2,  glow: 0,   disp: 0.9,  press: 0, xr: 1 },
    { ry: -0.6,  rx: 0.06, z: 6.0, y: 0,     tx: 0,     x: -0.2, glow: 0.6, disp: 0.4,  press: 0, xr: 0 },
  ];
  STOPS = [[0, [0.16, 0.36, 1]], [0.35, [0.54, 0.24, 1]], [0.65, [1, 0.24, 0.43]], [1, [1, 0.48, 0.1]]];
  thermal(t) {
    const S = this.STOPS; t = Math.max(0, Math.min(1, t));
    for (let i = 1; i < S.length; i++) if (t <= S[i][0]) {
      const u = (t - S[i - 1][0]) / (S[i][0] - S[i - 1][0]), a = S[i - 1][1], b = S[i][1];
      return [0, 1, 2].map((j) => a[j] + (b[j] - a[j]) * u);
    }
    return S[S.length - 1][1];
  }

  componentDidMount() {
    this.alive = true;
    this.cur = { ...this.KF[0] };
    this.mouse = { x: 0, y: 0, tx: 0, ty: 0 };
    this.amberMats = []; this.dispMats = []; this.buttons = [];
    this.onResize = () => { this.measure(); this.sizeRenderer(); };
    this.onMove = (e) => { if (this.rm || this.drag) return; this.mouse.tx = e.clientX / innerWidth - 0.5; this.mouse.ty = e.clientY / innerHeight - 0.5; };
    window.addEventListener('resize', this.onResize);
    window.addEventListener('pointermove', this.onMove);
    { const pace = parseFloat(new URLSearchParams(location.search).get('pace')); const tr = this.trackRef.current; if (tr && pace > 0.3 && pace <= 1.5) tr.querySelectorAll('[data-beat]').forEach((el) => { el.style.height = Math.max(100, parseFloat(el.style.height) * pace).toFixed(0) + 'vh'; }); }
    this.measure();
    this.last = performance.now();
    const loop = (now) => { if (!this.alive) return; this.frame(now); this.raf = requestAnimationFrame(loop); };
    this.raf = requestAnimationFrame(loop);
    this.rm = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    this.onVis = () => { if (document.hidden) cancelAnimationFrame(this.raf); else { this.last = performance.now(); this.raf = requestAnimationFrame(loop); } };
    document.addEventListener('visibilitychange', this.onVis);
    this.showTitle(0);
    this.initVideo();
    this.modelObserver = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.modelObserver.disconnect();
      this.boot().catch((error) => {
        console.error(error);
        const loading = this.q('[data-x=loading]');
        if (loading) loading.textContent = '3D view unavailable';
      });
    }, { rootMargin: '100% 0px' });
    this.modelObserver.observe(this.trackRef.current);
  }

  componentWillUnmount() {
    this.alive = false;
    if (this.modelObserver) this.modelObserver.disconnect();
    cancelAnimationFrame(this.raf);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('pointermove', this.onMove);
    document.removeEventListener('visibilitychange', this.onVis);
    if (this.videoPlayer) this.videoPlayer.destroy().catch(() => {});
    if (this.renderer) { const el = this.renderer.domElement; el.removeEventListener('pointerdown', this.onDeviceDown); el.removeEventListener('pointermove', this.onDeviceMove); el.removeEventListener('pointerup', this.onDeviceEnd); el.removeEventListener('pointercancel', this.onDeviceEnd); el.removeEventListener('lostpointercapture', this.onDeviceEnd); this.renderer.dispose(); el.remove(); }
  }

  q(sel) { return this.rootRef.current && this.rootRef.current.querySelector(sel); }

  initVideo() {
    const frame = this.q('[data-x=video]'), sound = this.q('[data-x=video-sound]'), play = this.q('[data-x=video-play]');
    if (!frame || !sound || !play) return;
    const showSound = (muted) => {
      sound.disabled = false;
      sound.textContent = muted ? 'UNMUTE' : 'MUTE';
      sound.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      sound.setAttribute('aria-pressed', String(!muted));
      frame.parentElement.dataset.sound = muted ? 'off' : 'on';
    };
    const showPlay = () => { play.hidden = false; frame.parentElement.dataset.videoState = 'paused'; };
    const attach = () => {
      if (!this.alive || !window.Vimeo || !window.Vimeo.Player) return;
      const player = new Vimeo.Player(frame);
      this.videoPlayer = player;
      const start = async (muted) => {
        await player.setMuted(muted);
        await player.play();
        if (!this.alive) return;
        play.hidden = true;
        frame.parentElement.dataset.videoState = 'playing';
        showSound(await player.getMuted());
      };
      sound.addEventListener('click', async () => {
        try {
          const muted = await player.getMuted();
          await player.setMuted(!muted);
          if (muted) await player.setVolume(1);
          showSound(await player.getMuted());
          if (await player.getPaused()) await player.play();
          play.hidden = true;
        } catch (e) { console.warn('Video sound change was blocked', e); }
      });
      play.addEventListener('click', () => { start(false).catch(showPlay); });
      player.on('volumechange', (event) => { if (this.alive) showSound(!!event.muted); });
      player.on('play', () => { if (this.alive) { play.hidden = true; frame.parentElement.dataset.videoState = 'playing'; } });
      player.on('pause', () => { if (this.alive) frame.parentElement.dataset.videoState = 'paused'; });
      player.ready().then(async () => {
        await player.setLoop(true).catch(() => {});
        try { await start(false); }
        catch (_) { try { await start(true); } catch (_) { if (this.alive) showPlay(); } }
      }).catch(() => { if (this.alive) showPlay(); });
    };
    if (window.Vimeo && window.Vimeo.Player) attach();
    else {
      const script = document.createElement('script');
      script.src = 'https://player.vimeo.com/api/player.js';
      script.async = true;
      script.onload = attach;
      script.onerror = showPlay;
      document.head.appendChild(script);
    }
  }

  isExploreView() {
    if (!this.renderer || !this.v2 || !this.v2.visible || (this.actDot !== 0 && this.actDot !== 5)) return false;
    const fade = this.beats && this.beats[this.actDot] && this.beats[this.actDot].fade;
    return !fade || !fade.style.opacity || Number(fade.style.opacity) > 0.8;
  }

  deviceHit(e) {
    if (!this.isExploreView()) return false;
    const rect = this.renderer.domElement.getBoundingClientRect();
    this.raycaster.setFromCamera({ x: (e.clientX - rect.left) / rect.width * 2 - 1, y: 1 - (e.clientY - rect.top) / rect.height * 2 }, this.cam);
    this.pivot.updateMatrixWorld(true);
    return this.raycaster.intersectObject(this.v2, true).length > 0;
  }

  bindDeviceDrag(THREE) {
    const el = this.renderer.domElement;
    this.raycaster = new THREE.Raycaster();
    this.spin = this.spinTarget = this.pitch = this.pitchTarget = 0;
    el.style.touchAction = 'pan-y';
    this.onDeviceDown = (e) => {
      if ((e.pointerType === 'mouse' && e.button !== 0) || !this.deviceHit(e)) return;
      this.drag = { id: e.pointerId, x: e.clientX, y: e.clientY };
      el.setPointerCapture(e.pointerId);
      el.style.cursor = 'grabbing';
      e.preventDefault();
    };
    this.onDeviceMove = (e) => {
      if (!this.drag || this.drag.id !== e.pointerId) {
        if (e.pointerType !== 'touch') el.style.cursor = this.deviceHit(e) ? 'grab' : '';
        return;
      }
      this.spinTarget += (e.clientX - this.drag.x) * 0.012;
      this.pitchTarget = Math.max(-0.35, Math.min(0.35, this.pitchTarget + (e.clientY - this.drag.y) * 0.004));
      this.drag.x = e.clientX; this.drag.y = e.clientY;
      e.preventDefault();
    };
    this.onDeviceEnd = (e) => {
      if (!this.drag || this.drag.id !== e.pointerId) return;
      this.drag = null;
      if (el.hasPointerCapture(e.pointerId)) el.releasePointerCapture(e.pointerId);
      el.style.cursor = e.pointerType !== 'touch' && this.deviceHit(e) ? 'grab' : '';
    };
    el.addEventListener('pointerdown', this.onDeviceDown);
    el.addEventListener('pointermove', this.onDeviceMove);
    el.addEventListener('pointerup', this.onDeviceEnd);
    el.addEventListener('pointercancel', this.onDeviceEnd);
    el.addEventListener('lostpointercapture', this.onDeviceEnd);
  }

  measure() {
    const track = this.trackRef.current; if (!track) return;
    this.vh = window.innerHeight;
    this.beats = [...track.querySelectorAll('[data-beat]')].map((el) => ({
      a: el.offsetTop, b: el.offsetTop + Math.max(0, el.offsetHeight - this.vh), fade: el.querySelector('[data-fade]'),
    }));
  }

  sizeRenderer() {
    const host = this.hostRef.current; if (!this.renderer || !host) return;
    this.renderer.setSize(host.clientWidth, host.clientHeight, false);
    this.cam.aspect = host.clientWidth / host.clientHeight; this.cam.updateProjectionMatrix();
  }

  async boot() {
    const R = this.resources || {};
    const local = {"three":"vendor/three.module.js","gltf":"vendor/GLTFLoader.js","roomenv":"vendor/RoomEnvironment.js","bgu":"vendor/BufferGeometryUtils.js","glbV2":"assets/device-v2.glb","glbXray":"assets/device-xray.glb","logo":"assets/stiiizy-logo.png","flame":"assets/flame-fill.png","allicons":"assets/screen-allicons.png"};
    const url = (id) => R[id] || new URL(local[id], location.href).href;
    const threeSource = await (await fetch(url('three'))).text();
    const threeUrl = URL.createObjectURL(new Blob([threeSource], { type: 'text/javascript' }));
    const rewrite = async (id, extra) => {
      let src = await (await fetch(url(id))).text();
      src = src.replace(/from\s*['"]three['"]/g, 'from "' + threeUrl + '"');
      if (extra) src = src.replace(/from\s*['"]\.\.\/utils\/BufferGeometryUtils\.js['"]/g, 'from "' + extra + '"');
      return URL.createObjectURL(new Blob([src], { type: 'text/javascript' }));
    };
    const bguUrl = await rewrite('bgu');
    const [THREE, { GLTFLoader }, { RoomEnvironment }] = await Promise.all([
      import(threeUrl), import(await rewrite('gltf', bguUrl)), import(await rewrite('roomenv')),
    ]);
    if (!this.alive) return;
    const host = this.hostRef.current;
    const r = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    r.setPixelRatio(Math.min(devicePixelRatio, 2));
    r.outputColorSpace = THREE.SRGBColorSpace;
    r.toneMapping = THREE.ACESFilmicToneMapping;
    r.toneMappingExposure = 1.05;
    r.setClearColor(0x000000, 0);
    r.domElement.style.cssText = 'width:100%;height:100%;display:block';
    host.appendChild(r.domElement);
    const scene = new THREE.Scene();
    scene.environment = new THREE.PMREMGenerator(r).fromScene(new RoomEnvironment(), 0.04).texture;
    const cam = new THREE.PerspectiveCamera(28, 1, 0.1, 100);
    const key = new THREE.DirectionalLight(0xffffff, 2.2); key.position.set(-3, 4, 5); scene.add(key);
    this.rimA = new THREE.DirectionalLight(0x9fc4ff, 3.5); this.rimA.position.set(4, 2, -5); scene.add(this.rimA);
    this.rimB = new THREE.DirectionalLight(0x9fc4ff, 1.6); this.rimB.position.set(-5, 1, -3); scene.add(this.rimB);

    const loader = new GLTFLoader();
    const gltf = await loader.loadAsync(url('glbV2'));
    if (!this.alive) return;
    const root = gltf.scene;
    const box = new THREE.Box3().setFromObject(root);
    const size = box.getSize(new THREE.Vector3()), c = box.getCenter(new THREE.Vector3());
    const s = 2 / size.y;
    const pivot = new THREE.Group(); scene.add(pivot);
    this.baseS = s; this.wraps = []; this.blackMats = [];
    const wrap = (r) => { r.position.sub(c); const g = new THREE.Group(); g.add(r); g.scale.setScalar(s); pivot.add(g); this.wraps.push(g); this.collectBlack(r); return g; };
    this.v2 = wrap(root);
    this.heat = 0;
    this.coilLight = new THREE.PointLight(0xff7a1a, 0, 0.3, 2); pivot.add(this.coilLight);
    loader.loadAsync(url('glbXray')).then((x) => { if (this.alive) this.setupXray(THREE, wrap(x.scene)); }).catch((e) => console.error(e));
    this.amberLight = new THREE.PointLight(0xff9a3a, 0, 3, 2);
    this.amberLight.position.set(-0.18, (0.032 - c.y) * s, 0.45); pivot.add(this.amberLight);
    this.dispLight = new THREE.PointLight(0x7cc4ff, 0, 2, 2);
    this.dispLight.position.set(0.9, (0.02 - c.y) * s, 0); pivot.add(this.dispLight);

    root.traverse((o) => {
      if (!o.isMesh) return;
      const n = (o.name || '') + '|' + ((o.parent && o.parent.name) || '');
      o.material = o.material.clone();
      if (n.includes('window_amber')) { o.material.emissive = new THREE.Color(0xff8a1f); this.amberMats.push(o.material); }
      if (n.includes('display_glass')) { this.mapScreen(THREE, o); this.glassMesh = o; }
      if (o.name === 'mouth_wall') this.mouthMesh = o;
      if (/power_button(?!_wall)/.test(n)) this.buttons.push({ m: o, base: o.position.clone() });
      if (o.name === 'usb_tongue') o.visible = false;
      this.logoFix(o);
    });
    this.flushUsb(root);

    const btn = this.buttons[0] && this.buttons[0].m;
    if (btn) {
      pivot.updateMatrixWorld(true);
      const bb = new THREE.Box3().setFromObject(btn), bc = bb.getCenter(new THREE.Vector3());
      this.btnA = bc.clone().setX(bb.max.x);
      this.btnP = [bc.clone().setX(bb.max.x).setZ(bb.min.z), bc.clone().setX(bb.max.x).setZ(bb.max.z), bc.clone().setX(bb.max.x).setY(bb.min.y), bc.clone().setX(bb.max.x).setY(bb.max.y)];
    }
    if (this.mouthMesh) {
      pivot.updateMatrixWorld(true);
      const mb = new THREE.Box3().setFromObject(this.mouthMesh), mc = mb.getCenter(new THREE.Vector3());
      this.mouth = { o: mc.clone().setY(mb.max.y), u: mc.clone().setY(mb.max.y + 0.5), l: mc.clone().setY(mb.max.y).setX(mb.min.x), r: mc.clone().setY(mb.max.y).setX(mb.max.x) };
    }
    this.inhale = 0; this.inhaleVis = 0;
    this.vec = new THREE.Vector3(); this.fxo = 0;
    Object.assign(this, { renderer: r, scene, cam, pivot });
    this.sizeRenderer();
    this.bindDeviceDrag(THREE);
    const l = this.q('[data-x=loading]'); if (l) l.style.display = 'none';
    host.style.opacity = '1';
    const po = this.q('[data-x=poster]'); if (po) po.style.opacity = '0';
    this.showTitle(600);
  }

  showTitle(ms) {
    clearTimeout(this.titleT);
    this.titleT = setTimeout(() => { const t = this.q('[data-x=herotitle]'); if (t) { t.style.opacity = '1'; t.style.transform = 'none'; } this.titleAt = performance.now(); }, ms);
  }

  collectBlack(root) {
    root.traverse((o) => { if (!o.isMesh) return; const nm = o.material && o.material.name; if (!/^(body_matte_black|cap_satin_black|mouth_insert)$/.test(nm || '')) return; if (/^usb_/.test(o.name)) return; o.userData.blk = { c: o.material.color.clone(), r: o.material.roughness }; });
  }

  applyLook() {
    const d = Math.max(0, Math.min(1, this.props.blackness ?? 1)), sl = Math.max(0, Math.min(30, this.props.slimDepth ?? 10)) / 100;
    const key = d + '|' + sl; if (key === this.lookKey || !this.wraps) return; this.lookKey = key;
    for (const g of this.wraps) { g.scale.set(this.baseS, this.baseS, this.baseS * (1 - sl)); g.traverse((o) => { const b = o.isMesh && o.userData.blk; if (!b) return; const m = o.material; m.color.copy(b.c).multiplyScalar(1 - d * 0.75); m.roughness = b.r + (0.9 - b.r) * d; m.metalness = 0; m.envMapIntensity = 1 - d * 0.55; }); }
  }

  logoFix(o) {
    if (o.name !== 'logo_wordmark') return;
    const m = o.material; o.renderOrder = 5; o.visible = true;
    m.polygonOffset = true; m.polygonOffsetFactor = -2; m.polygonOffsetUnits = -2; m.depthWrite = false;
    m.emissive = m.color.clone().multiplyScalar(0.35); m.emissiveMap = m.map || null; m.needsUpdate = true;
  }

  flushUsb(root) {
    let body = null; root.traverse((o) => { if (o.isMesh && o.name === 'lower_shell') body = o.material; });
    if (!body) return;
    root.traverse((o) => { if (!o.isMesh || !/^usb_(opening|backer|shell|cavity|floor)$/.test(o.name)) return; const m = o.material; m.color.copy(body.color); m.roughness = body.roughness; m.metalness = body.metalness; m.map = body.map || null; m.needsUpdate = true; });
  }

  mapScreen(THREE, o) {
    const g = o.geometry, pos = g.attributes.position;
    g.computeBoundingBox(); const bb = g.boundingBox, uv = new Float32Array(pos.count * 2);
    for (let i = 0; i < pos.count; i++) {
      uv[i * 2] = (bb.max.z - pos.getZ(i)) / (bb.max.z - bb.min.z);
      uv[i * 2 + 1] = (pos.getY(i) - bb.min.y) / (bb.max.y - bb.min.y);
    }
    g.setAttribute('uv', new THREE.BufferAttribute(uv, 2));
    if (!this.screenTex) { this.screenTex = new THREE.CanvasTexture(this.screenCanvas()); this.screenTex.colorSpace = THREE.SRGBColorSpace; this.screenTex.anisotropy = 4; }
    const m = o.material;
    m.map = null; m.color = new THREE.Color(0x000000); m.emissive = new THREE.Color(0xffffff); m.emissiveMap = this.screenTex; m.needsUpdate = true;
    this.dispMats.push(m);
  }

  screenCanvas() {
    if (!this.scrCv) {
      this.scrCv = this.q('[data-x=screen]') || Object.assign(document.createElement('canvas'), { width: 300, height: 740 });
      const img = Object.assign(new Image(), { crossOrigin: 'anonymous' });
      img.onload = () => {
        const w = 900, h = Math.round(w * img.height / img.width), c = Object.assign(document.createElement('canvas'), { width: w, height: h }), x = c.getContext('2d');
        x.drawImage(img, 0, 0, w, h);
        const d = x.getImageData(0, 0, w, h).data; let x0 = w, y0 = h, x1 = 0, y1 = 0;
        for (let yy = 0; yy < h; yy++) for (let xx = 0; xx < w; xx++) if (d[(yy * w + xx) * 4 + 3] > 20) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
        const o = Object.assign(document.createElement('canvas'), { width: x1 - x0 + 1, height: y1 - y0 + 1 }), ox = o.getContext('2d');
        ox.drawImage(c, -x0, -y0); ox.globalCompositeOperation = 'source-in'; ox.fillStyle = '#fff'; ox.fillRect(0, 0, o.width, o.height);
        this.logoW = o;
      };
      img.src = (this.resources && this.resources.logo) || 'assets/stiiizy-logo.png';
    }
    return this.scrCv;
  }

  flameTint(G) {
    if (!this.flameImg) { this.flameImg = Object.assign(new Image(), { crossOrigin: 'anonymous' }); this.flameImg.src = (this.resources && this.resources.flame) || 'assets/flame-fill.png'; this.flameCache = {}; }
    const im = this.flameImg; if (!im.complete || !im.naturalWidth) return null;
    const k = G.join(); if (this.flameCache[k]) return this.flameCache[k];
    const w = 240, h = Math.round(w * im.naturalHeight / im.naturalWidth), c = Object.assign(document.createElement('canvas'), { width: w, height: h }), x = c.getContext('2d');
    x.drawImage(im, 0, 0, w, h); x.globalCompositeOperation = 'source-in';
    const gr = x.createLinearGradient(0, 0, 0, h); gr.addColorStop(0, G[0]); gr.addColorStop(1, G[1]); x.fillStyle = gr; x.fillRect(0, 0, w, h);
    return (this.flameCache[k] = c);
  }

  flamePath(x) {
    x.beginPath();
    x.moveTo(0.5, 0); x.bezierCurveTo(0.62, 0.25, 1.0, 0.45, 0.93, 0.82); x.bezierCurveTo(0.87, 1.12, 0.64, 1.25, 0.5, 1.25);
    x.bezierCurveTo(0.2, 1.25, 0.02, 1.05, 0.06, 0.78); x.bezierCurveTo(0.09, 0.58, 0.2, 0.46, 0.27, 0.32);
    x.bezierCurveTo(0.29, 0.5, 0.35, 0.6, 0.44, 0.63); x.bezierCurveTo(0.37, 0.4, 0.41, 0.17, 0.5, 0); x.closePath();
  }
  innerPath(x) {
    x.beginPath();
    x.moveTo(0.56, 0.6); x.bezierCurveTo(0.74, 0.78, 0.76, 1.0, 0.62, 1.1); x.bezierCurveTo(0.5, 1.18, 0.34, 1.09, 0.36, 0.95);
    x.bezierCurveTo(0.38, 0.83, 0.52, 0.8, 0.56, 0.6); x.closePath();
  }

  drawScreen(now, sc) {
    const cv = this.screenCanvas(), x = cv.getContext('2d'), W = cv.width, H = cv.height;
    const B = this.beats && this.beats[2];
    const active = B && sc > B.a - this.vh * 0.6;
    const p = B ? Math.max(0, Math.min(0.9999, (sc - B.a) / Math.max(1, B.b - B.a))) : 0;
    const after = B && sc > B.b + this.vh * 0.5;
    const idx = active && !after ? Math.floor(p * 5) : 1, lt = p * 5 - Math.floor(p * 5);
    if (idx !== this.lastIdx) {
      this.lastIdx = idx;
      (this.rootRef.current ? [...this.rootRef.current.querySelectorAll('[data-state]')] : []).forEach((el) => { const on = +el.dataset.state === idx; el.style.opacity = on ? '1' : '0'; el.style.transform = on ? 'none' : 'translateY(8px)'; });
      (this.rootRef.current ? [...this.rootRef.current.querySelectorAll('[data-step]')] : []).forEach((el) => {
        const step = +el.dataset.step, on = step <= idx;
        const color = ['#3ea6ee', '#ffffff', '#bb72c8'][step];
        el.style.color = color; el.style.borderTopColor = color; el.style.opacity = on ? '1' : '0.55';
      });
      (this.rootRef.current ? [...this.rootRef.current.querySelectorAll('[data-status]')] : []).forEach((el) => {
        el.dataset.active = (idx === 3 && el.dataset.status === 'preheat') || (idx === 4 && el.dataset.status === 'charge') ? 'true' : 'false';
      });
    }
    const vh = this.vh || innerHeight, B0 = this.beats && this.beats[0], B5 = this.beats && this.beats[5];
    const inHero = B0 && sc < B0.b + vh * 0.3;
    if (inHero && this.titleAt) { if (!this.poT0) this.poT0 = Math.max(now, this.titleAt + 900); } else this.poT0 = 0;
    const pu = this.poT0 ? (now - this.poT0) / 1000 : -1; this.po = { u: pu };
    this.poAv = (this.poAv || 0) + ((pu >= 0 ? 1 : 0) - (this.poAv || 0)) * 0.14;
    const poA = this.poAv < 0.005 ? 0 : Math.min(1, this.poAv);
    this.scrBoost = poA;
    if (inHero || !active || (B5 && sc > B5.a - vh * 0.5)) {
      x.fillStyle = '#000'; x.fillRect(0, 0, W, H);
      if (poA > 0) {
        if (!this.allIcons) { this.allIcons = Object.assign(new Image(), { crossOrigin: 'anonymous' }); this.allIcons.src = (this.resources && this.resources.allicons) || 'assets/screen-allicons.png'; }
        const im = this.allIcons;
        if (im.complete && im.naturalWidth) { const y0 = H * 0.27, y1 = H * 0.93, sc2 = Math.min(W * 0.7 / im.naturalWidth, (y1 - y0) / im.naturalHeight), iw = im.naturalWidth * sc2, ih = im.naturalHeight * sc2; x.globalAlpha = poA; x.drawImage(im, (W - iw) / 2, y0 + (y1 - y0 - ih) / 2, iw, ih); x.globalAlpha = 1; }
      }
      if (this.screenTex) this.screenTex.needsUpdate = true;
      return;
    }
    const VC = ['#3ea6ee', '#ffffff', '#bb72c8'];
    const lvl = idx <= 2 ? idx : 1, charging = idx === 4, preheat = idx === 3;
    const fire = after ? this.inhale > 0.3 : active && (preheat || (idx <= 2 && lt > 0.3));
    this.scrCol = charging ? '#63d681' : preheat ? '#ff9a1f' : VC[lvl];
    x.fillStyle = '#000'; x.fillRect(0, 0, W, H);
    if (!charging) {
      if (this.logoW && this.props.screenLogo) { const lw = W * 0.66, lh = lw * this.logoW.height / this.logoW.width; x.drawImage(this.logoW, (W - lw) / 2, H * 0.08, lw, lh); }
      const cx = W / 2, cy = H * 0.5, r = W * 0.36, A = [[-160, -122], [-110, -70], [-58, -20]][lvl], d2r = Math.PI / 180;
      x.strokeStyle = VC[lvl]; x.lineWidth = W * 0.09; x.lineCap = 'butt';
      x.beginPath(); x.arc(cx, cy, r, A[0] * d2r, A[1] * d2r); x.stroke();
      const am = (A[0] + A[1]) / 2 * d2r;
      x.fillStyle = '#000'; x.font = '700 ' + Math.round(W * 0.06) + 'px Helvetica, Arial, sans-serif'; x.textAlign = 'center'; x.textBaseline = 'middle';
      x.fillText('LMH'[lvl], cx + Math.cos(am) * r, cy + Math.sin(am) * r + 1);
      if (fire) {
        const G = preheat ? ['#ffd23a', '#ff8a1a'] : [['#8fd0ff', '#2b8fe0'], ['#ffffff', '#ffffff'], ['#e2a6ea', '#a35bb2']][lvl];
        const fl = this.flameTint(G);
        if (fl) {
          const fh = H * 0.26, fw = fh * fl.width / fl.height, fy = cy - fh * 0.42;
          const al = preheat ? (Math.floor(now / 500) % 2 ? 0 : 1) : 0.4 + 0.6 * (0.5 - 0.5 * Math.cos(now * Math.PI * 2 / 2400));
          x.globalAlpha = al; x.drawImage(fl, cx - fw / 2, fy, fw, fh); x.globalAlpha = 1;
        }
      }
    }
    const by = H * 0.86, bh = H * 0.065, n = charging ? 1 + Math.floor(now / 650) % 4 : 4;
    const ix = W * 0.1, iw = W * 0.09;
    x.fillStyle = charging ? '#63d681' : '#fff'; x.strokeStyle = x.fillStyle;
    { const lw = iw * 0.16, top = by + bh * 0.1, bodyH = bh * 0.9;
      x.beginPath(); x.roundRect(ix + iw * 0.3, by - bh * 0.02, iw * 0.4, bh * 0.16, [iw * 0.08, iw * 0.08, 0, 0]); x.fill();
      x.lineWidth = lw; x.beginPath(); x.roundRect(ix + lw / 2, top + lw / 2, iw - lw, bodyH - lw, iw * 0.16); x.stroke();
      const cx = ix + iw / 2, cy = top + bodyH / 2, s = bodyH * 0.3;
      x.beginPath(); x.moveTo(cx + s * 0.32, cy - s); x.lineTo(cx - s * 0.36, cy + s * 0.12); x.lineTo(cx - s * 0.02, cy + s * 0.12); x.lineTo(cx - s * 0.3, cy + s); x.lineTo(cx + s * 0.38, cy - s * 0.14); x.lineTo(cx + s * 0.04, cy - s * 0.14); x.closePath(); x.fill(); }
    const bx0 = W * 0.3, bw = W * 0.1, gap = W * 0.06;
    for (let i = 0; i < n; i++) { x.beginPath(); x.roundRect(bx0 + i * (bw + gap), by, bw, bh, bw / 2); x.fill(); }
    if (this.screenTex) this.screenTex.needsUpdate = true;
  }

  setupXray(THREE, model) {
    this.lookKey = null;
    const INNER = new Set(['inner_shell', 'inner_shell_base', 'shell_deck', 'airway_tube', 'airway_bore', 'airway_chimney', 'airway_chimney_top', 'fill_port', 'tank_divider', 'atomizer_base', 'ceramic_holder', 'ceramic_core', 'heating_film', 'electrode_pin_1', 'electrode_pin_2']);
    const HIDE = /^(battery|pcb|mcu|charge_ic|tact_switch|smd_cap|display_module|display_flex|usb_receptacle|wire_)/;
    this.pinMats = [];
    this.cut = { inv: { value: new THREE.Matrix4() }, x: { value: 0 }, bmin: { value: new THREE.Vector3() }, bmax: { value: new THREE.Vector3() }, fe: { value: 0.02 } };
    const cut = this.cut;
    const xrayMat = (mat, inner, a0, a1) => {
      mat.transparent = true;
      mat.onBeforeCompile = (sh) => {
        Object.assign(sh.uniforms, { uInv: cut.inv, uX: cut.x, uBMin: cut.bmin, uBMax: cut.bmax, uFe: cut.fe, uA0: { value: a0 }, uA1: { value: a1 } });
        sh.vertexShader = 'varying vec3 vCutW;\nuniform mat4 uInv;\n' + sh.vertexShader.replace('#include <project_vertex>', '#include <project_vertex>\nvCutW = (uInv * modelMatrix * vec4(transformed, 1.0)).xyz;');
        sh.fragmentShader = 'varying vec3 vCutW;\nuniform vec3 uBMin;\nuniform vec3 uBMax;\nuniform float uFe;\nuniform float uX;\nuniform float uA0;\nuniform float uA1;\n' + sh.fragmentShader.replace('#include <dithering_fragment>', '#include <dithering_fragment>\n' +
          'vec3 bl = smoothstep(uBMin - uFe, uBMin, vCutW) * (1.0 - smoothstep(uBMax, uBMax + uFe, vCutW));\nfloat inR = bl.x * bl.y * bl.z;\n' +
          'float fres = pow(1.0 - abs(dot(normalize(normal), normalize(vViewPosition))), 2.0);\n' +
          'float xa = (uA0 < 0.0) ? gl_FragColor.a : mix(uA0, uA1, fres);\n' +
          (inner ? 'gl_FragColor.a = xa * inR * uX;\nif (gl_FragColor.a < 0.004) discard;'
                 : 'gl_FragColor.a = mix(gl_FragColor.a, xa, uX * inR);'));
      };
      mat.customProgramCacheKey = () => 'xr' + (inner ? 'i' : 'o') + (a0 < 0 ? 's' : 'f');
    };
    const named = {};
    model.traverse((o) => {
      if (!o.isMesh) return;
      named[o.name] = o;
      o.material = o.material.clone();
      const mat = o.material, u = mat.userData && mat.userData.u;
      const a0 = u ? u.uA0.value : -1, a1 = u ? u.uA1.value : -1;
      if (INNER.has(o.name) || HIDE.test(o.name)) { xrayMat(mat, true, a0, a1); mat.depthWrite = !u; o.renderOrder = u ? 1 : 0; }
      else if (u) { xrayMat(mat, false, a0, a1); o.renderOrder = 2; }
      if (o.name === 'ceramic_core') { mat.emissive = new THREE.Color(0); mat.emissiveMap = mat.map || null; this.coreMat = mat; }
      if (o.name === 'heating_film') { mat.emissive = new THREE.Color(0); this.filmMat = mat; }
      if (o.name.startsWith('electrode_pin')) { mat.emissive = new THREE.Color(0); this.pinMats.push(mat); }
      if (o.name === 'display_glass') this.mapScreen(THREE, o);
      if (/^usb_/.test(o.name) || o.name === 'pcb_usb') o.visible = false;
      const KEEP = /^(ceramic_holder|ceramic_core|heating_film)/;
      if ((INNER.has(o.name) || HIDE.test(o.name)) && !KEEP.test(o.name)) o.visible = false;
      this.logoFix(o);
    });
    const bodyM = named.lower_shell && named.lower_shell.material;
    if (bodyM) ['body_rim', 'body_gap_floor'].forEach((k) => { const o = named[k]; if (!o) return; const m = bodyM.clone(); m.onBeforeCompile = () => {}; m.customProgramCacheKey = () => 'rimop'; m.transparent = false; m.opacity = 1; m.depthWrite = true; m.needsUpdate = true; o.material = m; o.renderOrder = 0; });
    this.flushUsb(model);
    model.visible = false;
    this.pivot.rotation.set(0, 0, 0);
    this.pivot.updateMatrixWorld(true);
    const bx = (n) => new THREE.Box3().setFromObject(named[n]);
    const core = bx('ceramic_core');
    const cc = core.getCenter(new THREE.Vector3());
    const shellBox = bx('lower_shell');
    const pm = (mmX, mmY) => [shellBox.min.x + (mmX + 20.525) / 41.05 * (shellBox.max.x - shellBox.min.x), shellBox.min.y + mmY / 46.8 * (shellBox.max.y - shellBox.min.y)];
    const [x1, y0] = pm(-2.0, 4.5), [, y1] = pm(0, 46.6);
    cut.bmin.value.set(-5, y0, -5); cut.bmax.value.set(x1, y1, 5);
    this.coilCenter = cc;
    this.coilLight.position.copy(cc).setZ(core.max.z + 0.05);
    const K = this.KF[1];
    K.tx = 0.5 * (cc.x * Math.cos(K.ry) + cc.z * Math.sin(K.ry));
    K.y = cc.y * 0.5;
    this.vec = new THREE.Vector3();
    this.xray = model;
  }

  breath(now, sc) {
    const B = this.beats && this.beats[4], vh = this.vh || innerHeight;
    const vis = B && sc > B.a - vh * 0.25 && sc < B.b + vh * 0.25 ? 1 : 0;
    if (vis && !this.b0) this.b0 = now; if (!vis) this.b0 = 0;
    let target = 0;
    if (vis) {
      const u = ((now - this.b0) / 1000) % 3.8;
      target = u < 0.4 ? 0 : u < 2.8 ? Math.sin(Math.min(1, (u - 0.4) / 0.5) * Math.PI / 2) : 0;
      this.smokeReach = Math.max(0, Math.min(1, (u - 0.4) / 1.7));
    }
    this.inhale += (target - this.inhale) * (target > this.inhale ? 0.08 : 0.05);
    this.inhaleVis += (vis - this.inhaleVis) * 0.08;
  }

  airflow(now, w, h) {
    const cv = this.q('[data-x=airflow]'); if (!cv) return;
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
    const x = cv.getContext('2d'); x.clearRect(0, 0, w, h);
    const amt = this.inhale * this.inhaleVis;
    if (amt < 0.01 || !this.mouth || this.rm) return;
    this.pivot.updateMatrixWorld();
    const O = this.project(this.mouth.o, w, h), U = this.project(this.mouth.u, w, h), Lp = this.project(this.mouth.l, w, h), Rp = this.project(this.mouth.r, w, h);
    let dx = U[0] - O[0], dy = U[1] - O[1]; const L = Math.hypot(dx, dy) * 1.5; dx /= L / 1.5; dy /= L / 1.5;
    const px = -dy, py = dx, t = now / 1000;
    x.globalCompositeOperation = 'lighter'; x.lineCap = 'round';
    const g = x.createRadialGradient(O[0], O[1], 0, O[0], O[1], L * 0.35);
    g.addColorStop(0, 'rgba(241,241,238,' + (0.22 * amt).toFixed(3) + ')'); g.addColorStop(1, 'rgba(241,241,238,0)');
    x.fillStyle = g; x.fillRect(O[0] - L, O[1] - L, L * 2, L * 2);
    this.smoke(x, O, dx, dy, px, py, L, t, amt);
    // Reveal the existing plume from the mouthpiece upward as each draw begins.
    const front = 0.08 + (this.smokeReach || 0) * 1.25;
    const start = Math.max(0, (front - 0.16 + 0.15) / 1.65);
    const end = Math.min(1, (front + 0.03 + 0.15) / 1.65);
    const reveal = x.createLinearGradient(O[0] - dx * L * 0.15, O[1] - dy * L * 0.15, O[0] + dx * L * 1.5, O[1] + dy * L * 1.5);
    reveal.addColorStop(0, '#fff'); reveal.addColorStop(start, '#fff');
    reveal.addColorStop(end, 'rgba(255,255,255,0)'); reveal.addColorStop(1, 'rgba(255,255,255,0)');
    x.globalCompositeOperation = 'destination-in';
    x.fillStyle = reveal; x.fillRect(0, 0, w, h);
    x.globalCompositeOperation = 'source-over';
  }

  smoke(x, O, dx, dy, px, py, L, t, amt) {
    x.save();
    x.globalCompositeOperation = 'screen';
    x.lineCap = 'round'; x.lineJoin = 'round';
    const P = (s, v) => [O[0] + dx * s * L + px * v * L, O[1] + dy * s * L + py * v * L];
    const D = (s, lateral, phase) => {
      const u = Math.max(0, Math.min(1, (s - 0.08) / 1.15));
      const bend = -0.82 * Math.sin(Math.PI * u) * Math.pow(u, 0.7);
      const twist = Math.sin(s * 6.7 - t * 0.48 + phase * 0.26) * 0.105 * s;
      const spread = lateral * (0.014 + 0.25 * s * s);
      return P(s, bend + twist + spread);
    };
    // Diffuse vapor follows the curl instead of forming a straight cone.
    for (let i = 0; i < 11; i++) {
      const age = (i / 11 + t * 0.055) % 1;
      const s = 0.21 + age * 0.98;
      const [cx, cy] = D(s, Math.sin(i * 2.4) * 0.8, i * 1.7);
      const radius = L * (0.10 + age * 0.25);
      x.save();
      x.translate(cx, cy); x.rotate(Math.sin(i * 2.2 + t * 0.18) * 0.35);
      x.scale(1.22, 0.64);
      const haze = x.createRadialGradient(0, 0, 0, 0, 0, radius);
      haze.addColorStop(0, 'rgba(231,230,232,' + (0.12 * amt * Math.sin(Math.PI * age)).toFixed(3) + ')');
      haze.addColorStop(0.55, 'rgba(225,224,228,' + (0.065 * amt * Math.sin(Math.PI * age)).toFixed(3) + ')');
      haze.addColorStop(1, 'rgba(225,224,228,0)');
      x.fillStyle = haze; x.fillRect(-radius, -radius, radius * 2, radius * 2);
      x.restore();
    }
    // Narrow wisps rise, veer left, and fold back toward the plume.
    for (let pass = 0; pass < 2; pass++) {
      x.filter = 'blur(' + (pass ? Math.max(1.1, L * 0.009) : Math.max(5, L * 0.036)).toFixed(1) + 'px)';
      for (let i = 0; i < 12; i++) {
        const lateral = (i - 5.5) / 5.5;
        const top = 1.08 + (i % 3) * 0.085;
        x.beginPath();
        for (let k = 0; k <= 30; k++) {
          const s = k / 30 * top;
          const [X, Y] = D(s, lateral, i * 1.17);
          if (k) x.lineTo(X, Y); else x.moveTo(X, Y);
        }
        const alpha = amt * (pass ? 0.060 : 0.085) * (1 - Math.abs(lateral) * 0.25);
        const grad = x.createLinearGradient(O[0], O[1], O[0] + dx * top * L, O[1] + dy * top * L);
        grad.addColorStop(0, 'rgba(237,235,238,' + (alpha * 0.45).toFixed(3) + ')');
        grad.addColorStop(0.28, 'rgba(237,235,238,' + alpha.toFixed(3) + ')');
        grad.addColorStop(0.75, 'rgba(235,233,237,' + (alpha * 0.75).toFixed(3) + ')');
        grad.addColorStop(1, 'rgba(235,233,237,0)');
        x.strokeStyle = grad;
        x.lineWidth = pass ? Math.max(1.5, L * (0.010 + (i % 3) * 0.003)) : L * (0.045 + (i % 4) * 0.010);
        x.stroke();
      }
    }
    // A looping ribbon gives the smoke the distinct twisting fold in the reference.
    for (let pass = 0; pass < 2; pass++) {
      x.filter = 'blur(' + (pass ? Math.max(1, L * 0.009) : Math.max(4, L * 0.032)).toFixed(1) + 'px)';
      for (let i = 0; i < 6; i++) {
        const offset = (i - 2.5) * 0.038;
        const drift = Math.sin(t * 0.42 + i * 0.67) * 0.045;
        const Q = (s, v) => P(s, v + offset + drift * s);
        const a = Q(0.04, 0), b = Q(0.31, 0.015), c = Q(0.48, -0.04), d = Q(0.56, -0.35);
        const e = Q(0.56, -0.69), f = Q(0.83, -0.95), g = Q(0.96, -0.72);
        const h = Q(1.06, -0.49), j = Q(0.88, -0.31), k = Q(0.73, -0.47);
        const m = Q(0.61, -0.64), n = Q(0.83, -0.87), o = Q(1.13, -0.80);
        x.beginPath(); x.moveTo(...a);
        x.bezierCurveTo(...b, ...c, ...d);
        x.bezierCurveTo(...e, ...f, ...g);
        x.bezierCurveTo(...h, ...j, ...k);
        x.bezierCurveTo(...m, ...n, ...o);
        const alpha = (pass ? 0.11 : 0.12) * amt;
        const grad = x.createLinearGradient(...a, ...o);
        grad.addColorStop(0, 'rgba(239,237,239,' + (alpha * 0.25).toFixed(3) + ')');
        grad.addColorStop(0.38, 'rgba(239,237,239,' + alpha.toFixed(3) + ')');
        grad.addColorStop(0.78, 'rgba(237,235,238,' + (alpha * 0.72).toFixed(3) + ')');
        grad.addColorStop(1, 'rgba(237,235,238,0)');
        x.strokeStyle = grad;
        x.lineWidth = pass ? L * (0.012 + i * 0.001) : L * (0.050 + i * 0.003);
        x.stroke();
      }
    }
    // Open, offset arcs keep the turn airy rather than a single opaque swoosh.
    x.filter = 'blur(' + Math.max(1.3, L * 0.012).toFixed(1) + 'px)';
    for (let i = 0; i < 4; i++) {
      const [cx, cy] = P(0.79 + i * 0.038, -0.66 - i * 0.03);
      x.beginPath();
      x.ellipse(cx, cy, L * (0.28 + i * 0.03), L * (0.12 + i * 0.018), -0.14 + i * 0.08, 0.22 + t * 0.08, 4.55 + t * 0.08);
      x.strokeStyle = 'rgba(238,236,239,' + (amt * (0.095 - i * 0.012)).toFixed(3) + ')';
      x.lineWidth = Math.max(1.2, L * (0.012 + i * 0.002));
      x.stroke();
    }
    x.restore();
  }

  buttonFx(now, sc, w, h) {
    const B = this.beats || [], vh = this.vh || innerHeight, t = now / 1000, TAP = 0.34;
    const inB = (b) => b && sc > b.a - vh * 0.3 && sc < b.b + vh * 0.3;
    let N = 0, u = 0, row = -1, vis = 0;
    if (inB(B[3])) {
      const P = [5, 2, 3], L = P.map((n) => n * TAP + 1.6), tot = L.reduce((a, b) => a + b, 0);
      if (this.pk !== 'b') { this.pk = 'b'; this.p0 = t; }
      u = (t - this.p0) % tot; let i = 0; while (i < 2 && u > L[i]) { u -= L[i]; i++; }
      N = P[i]; row = i; vis = 1;
    } else if (inB(B[2]) && this.lastIdx != null) {
      const n = [3, 3, 3, 2, 0][this.lastIdx] || 0, key = 'd' + this.lastIdx;
      if (this.pk !== key) { this.pk = key; this.p0 = t; }
      N = n; u = (t - this.p0) % (n * TAP + 2); vis = n ? 1 : 0;
    } else this.pk = null;
    if (row !== this.lastRow) {
      this.lastRow = row;
      (this.rootRef.current ? [...this.rootRef.current.querySelectorAll('[data-press]')] : []).forEach((el) => { el.style.opacity = row < 0 || +el.dataset.press === row ? '1' : '0.35'; });
    }
    const ages = []; let press = 0;
    for (let k = 0; k < N; k++) { const a = u - 0.3 - k * TAP; if (a >= 0) { ages.push(a); if (a < 0.3) press = Math.max(press, Math.exp(-a / 0.07)); } }
    this.fxo += (vis - this.fxo) * 0.12;
    const fx = this.q('[data-x=btnfx]');
    if (!fx || !this.btnA) return press;
    fx.style.opacity = this.fxo.toFixed(3);
    if (this.fxo < 0.01) return press;
    this.cam.updateMatrixWorld(); this.pivot.updateMatrixWorld();
    const [cx, cy] = this.project(this.btnA, w, h);
    const p = this.btnP.map((v) => this.project(v, w, h));
    const bw = Math.hypot(p[1][0] - p[0][0], p[1][1] - p[0][1]) + 12, bh = Math.max(14, Math.hypot(p[3][0] - p[2][0], p[3][1] - p[2][1]) + 10);
    const ang = Math.atan2(p[1][1] - p[0][1], p[1][0] - p[0][0]);
    fx.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px) rotate(' + ang.toFixed(3) + 'rad)';
    fx.querySelectorAll('[data-ring],[data-ripple]').forEach((el) => { el.style.width = bw.toFixed(1) + 'px'; el.style.height = bh.toFixed(1) + 'px'; el.style.borderRadius = (bh * 0.3).toFixed(1) + 'px'; });
    const base = fx.querySelector('[data-ring]');
    if (base) { base.style.opacity = (0.5 + press * 0.5).toFixed(3); base.style.transform = 'translate(-50%,-50%) scale(' + (1 - press * 0.08).toFixed(3) + ')'; }
    fx.querySelectorAll('[data-ripple]').forEach((el, j) => {
      const a = ages[j];
      if (a == null || a > 0.9) { el.style.opacity = '0'; return; }
      el.style.opacity = ((1 - a / 0.9) * 0.9).toFixed(3);
      el.style.transform = 'translate(-50%,-50%) scale(' + (1 + a * 1.8).toFixed(3) + ')';
    });
    const tl = this.q('[data-x=tally]');
    if (tl) {
      const done = ages.length;
      tl.style.opacity = this.fxo.toFixed(3);
      tl.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px) translate(-50%,-50%)';
      const c = tl.querySelector('[data-x=tcount]'); if (c) { c.textContent = done ? done + '×' : ''; c.style.opacity = done ? '1' : '0'; }
      if (done !== this.lastDone) {
        this.lastDone = done;
        if (done > 0 && row >= 0) { const num = this.q('[data-press="' + row + '"] > div:first-child'); if (num) { num.classList.remove('x-pop'); void num.offsetWidth; num.classList.add('x-pop'); } }
      }
    }
    return press;
  }

  project(p, w, h) {
    const v = this.vec.copy(p).applyMatrix4(this.pivot.matrixWorld).project(this.cam);
    return [(v.x + 1) / 2 * w, (1 - v.y) / 2 * h];
  }

  target(sc) {
    const B = this.beats, K = this.KF;
    if (!B || !B.length || sc <= B[0].a) return K[0];
    for (let i = 0; i < B.length; i++) {
      if (sc <= B[i].b) return K[i];
      if (i + 1 < B.length && sc < B[i + 1].a) {
        let t = (sc - B[i].b) / (B[i + 1].a - B[i].b);
        t = t * t * (3 - 2 * t);
        const o = {};
        for (const k in K[i]) o[k] = K[i][k] + (K[i + 1][k] - K[i][k]) * t;
        return o;
      }
    }
    return K[K.length - 1];
  }

  frame(now) {
    const dt = Math.min(0.05, (now - this.last) / 1000); this.last = now;
    const track = this.trackRef.current; if (!track) return;
    const sc = -track.getBoundingClientRect().top;
    const vh = this.vh || innerHeight;
    const narrow = innerWidth < 760;
    const tgt = this.target(sc);
    const k = 1 - Math.exp(-dt * 6);
    for (const key in tgt) this.cur[key] += (tgt[key] - this.cur[key]) * k;
    const m = this.mouse; m.x += (m.tx - m.x) * k; m.y += (m.ty - m.y) * k;
    const cur = this.cur;
    const g = cur.glow * (this.props.glowStrength ?? 1);
    const shift = narrow ? 0 : cur.x;

    const wm = this.q('[data-x=wordmark]');
    if (wm) wm.style.opacity = String(Math.max(0, 1 - sc / (vh * 0.7)));
    const gl = this.q('[data-x=glow]');
    if (gl) gl.style.left = (50 + shift * 100) + '%';
    (this.beats || []).forEach((b, i) => {
      if (!b.fade) return;
      let dist = sc < b.a ? b.a - sc : sc > b.b ? sc - b.b : 0;
      if (i === 0 && sc < b.a) dist = 0;
      if (i === this.beats.length - 1 && sc > b.b) dist = 0;
      const o = Math.max(0, Math.min(1, 1 - (dist - vh * 0.1) / (vh * 0.35)));
      b.fade.style.opacity = o.toFixed(3);
      b.fade.style.transform = 'translateY(' + ((sc < b.a ? 1 : -1) * (1 - o) * 40).toFixed(1) + 'px)';
    });

    this.chrome(sc, vh, narrow);
    if (!this.renderer || sc < -vh || sc > track.offsetHeight) return;
    if (!this.isExploreView()) {
      if (this.drag) { const id = this.drag.id; this.drag = null; if (this.renderer.domElement.hasPointerCapture(id)) this.renderer.domElement.releasePointerCapture(id); }
      this.spin = Math.atan2(Math.sin(this.spin), Math.cos(this.spin));
      this.spinTarget = this.pitchTarget = 0;
      this.renderer.domElement.style.cursor = '';
    }
    this.spin += (this.spinTarget - this.spin) * Math.min(1, dt * 12);
    this.pitch += (this.pitchTarget - this.pitch) * Math.min(1, dt * 12);
    this.pivot.rotation.set(cur.rx + m.y * 0.06 + this.pitch, cur.ry + (this.rm ? 0 : Math.sin(now * 0.0004) * 0.04) + m.x * 0.1 + this.spin, 0);
    const z = narrow ? Math.max(cur.z, 3.6) * 1.45 : cur.z, tx = narrow ? cur.tx * 0.4 : cur.tx;
    this.cam.position.set(tx, cur.y, z);
    this.cam.lookAt(tx, cur.y, 0);
    const host = this.hostRef.current, w = host.clientWidth, h = host.clientHeight;
    this.cam.setViewOffset(w, h, -shift * w, narrow ? h * 0.15 : 0, w, h);
    this.breath(now, sc);
    const beat = this.buttonFx(now, sc, w, h);
    for (const b of this.buttons) { b.m.position.copy(b.base); b.m.position.x -= beat * 0.6; }
    for (const mat of this.amberMats) mat.emissiveIntensity = 0.12 + g * 1.6;
    this.drawScreen(now, sc);
    for (const mat of this.dispMats) mat.emissiveIntensity = Math.max(cur.disp, this.scrBoost || 0) * 0.9;
    const sg = this.q('[data-x=scrglow]');
    if (sg && this.glassMesh) {
      const a = this.scrBoost || 0; sg.style.opacity = (a * 0.9).toFixed(3);
      if (a > 0) { if (!this.glassC) { const T = this.glassMesh.geometry; T.computeBoundingBox(); this.glassC = T.boundingBox.getCenter(this.vec.clone()); }
        this.pivot.updateMatrixWorld(); this.cam.updateMatrixWorld();
        const v = this.glassC.clone().applyMatrix4(this.glassMesh.matrixWorld).project(this.cam), gx = (v.x + 1) / 2 * w, gy = (1 - v.y) / 2 * h, sz = Math.min(w, h) * 0.4;
        sg.style.transform = 'translate(' + (gx - sz / 2).toFixed(1) + 'px,' + (gy - sz / 2).toFixed(1) + 'px)'; }
    }
    this.amberLight.intensity = g * 1.2;
    this.dispLight.intensity = 0; if (this.scrCol) this.dispLight.color.set(this.scrCol);
    this.applyLook();
    const rim = { Cool: 0x9fc4ff, Warm: 0xffb27a, Neutral: 0xffffff }[this.props.rimTone ?? 'Neutral'] ?? 0xffffff;
    this.rimA.color.setHex(rim); this.rimB.color.setHex(rim);
    this.coil(now, sc, w, h, narrow, k);
    this.airflow(now, w, h);
    this.renderer.render(this.scene, this.cam);
  }

  coil(now, sc, w, h, narrow, k) {
    const glowEl = this.q('[data-x=coilglow]'), mark = this.q('[data-x=heatmark]');
    const xr0 = this.xray ? Math.max(0, Math.min(1, this.cur.xr)) : 0, xt = Math.max(0, Math.min(1, (xr0 - 0.7) / 0.3)), xr = xt * xt * (3 - 2 * xt);
    if (this.xray) { this.xray.visible = xr > 0.01; this.v2.visible = !this.xray.visible; }
    const B = this.beats && this.beats[1];
    const p = B ? Math.max(0, Math.min(1, (sc - B.a) / Math.max(1, B.b - B.a))) : 0;
    const ss = (a, b, x) => { const t = Math.max(0, Math.min(1, (x - a) / (b - a))); return t * t * (3 - 2 * t); };
    const B4 = this.beats && this.beats[4], inh = B4 && sc > B4.a - this.vh * 0.6;
    this.heat += ((inh ? this.inhale : ss(0.08, 0.8, p)) - this.heat) * k;
    const heat = this.heat;
    if (mark) mark.style.left = (heat * 100).toFixed(1) + '%';
    const thermal = (this.props.coilEffect ?? 'Thermal ramp') === 'Thermal ramp';
    const col = thermal ? this.thermal(heat) : [1, 0.48, 0.1];
    const flick = 0.82 + 0.12 * Math.sin(now * 0.0029) + 0.06 * Math.sin(now * 0.0083 + 1.3);
    const pulse = 1 + (flick - 1) * (0.4 + heat);
    const amt = xr * (thermal ? 0.3 + heat * 1.7 : heat * 2) * pulse;
    if (this.coreMat) { this.coreMat.emissive.setRGB(col[0], col[1], col[2]); this.coreMat.emissiveIntensity = amt * 1.6; }
    if (this.filmMat) { this.filmMat.emissive.setRGB(col[0], col[1], col[2]); this.filmMat.emissiveIntensity = amt * 2.4; }
    for (const m of this.pinMats || []) { m.emissive.setRGB(col[0], col[1], col[2]); m.emissiveIntensity = amt * 0.35; }
    this.coilLight.color.setRGB(col[0], col[1], col[2]); this.coilLight.intensity = amt * 1.2;
    if (!this.coilCenter) { if (glowEl) glowEl.style.opacity = '0'; return; }
    this.cut.inv.value.copy(this.pivot.matrixWorld).invert(); this.cut.x.value = xr;
    this.cam.updateMatrixWorld(); this.pivot.updateMatrixWorld();
    const [cx, cy] = this.project(this.coilCenter, w, h);
    if (glowEl) {
      const sz = Math.min(w, h) * (0.18 + heat * 0.14);
      const rgb = col.map((v) => Math.round(v * 255)).join(',');
      glowEl.style.width = glowEl.style.height = sz + 'px';
      glowEl.style.transform = 'translate(' + (cx - sz / 2).toFixed(1) + 'px,' + (cy - sz / 2).toFixed(1) + 'px)';
      glowEl.style.background = 'radial-gradient(closest-side, rgba(' + rgb + ',0.55), rgba(' + rgb + ',0.18) 45%, rgba(' + rgb + ',0) 100%)';
      glowEl.style.opacity = Math.min(1, amt * 0.45).toFixed(3);
    }

  }

  go(i) {
    const track = this.trackRef.current, vh = this.vh || innerHeight; if (!track) return;
    let y = 0;
    if (i >= 6) { const el = this.q('[data-sec="' + i + '"]'); if (el) y = el.getBoundingClientRect().top + scrollY - 72; }
    else if (i > 0 && this.beats && this.beats[i]) { const b = this.beats[i]; y = track.getBoundingClientRect().top + scrollY + b.a + (b.b - b.a) * 0.15; }
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  setMenu(on) {
    const m = this.q('[data-x=menu]'); if (!m) return;
    m.style.opacity = on ? '1' : '0'; m.style.pointerEvents = on ? 'auto' : 'none';
    document.body.style.overflow = on ? 'hidden' : '';
    if (!this.onKey) { this.onKey = (e) => { if (e.key === 'Escape') this.setMenu(false); }; window.addEventListener('keydown', this.onKey); }
  }

  chrome(sc, vh, narrow) {
    const nav = this.q('[data-x=nav]'), y = window.scrollY;
    const pageEnded = this.rootRef.current.getBoundingClientRect().bottom < vh;
    if (nav) nav.style.transform = 'translateX(-50%)' + (y > 24 && !pageEnded ? '' : ' translateY(-110%)');
    const dots = this.q('[data-x=dots]'); if (dots) dots.style.display = narrow || sc < 0 || pageEnded ? 'none' : 'flex';
    let act = 0; const B = this.beats || [];
    for (let i = 0; i < B.length; i++) if (sc >= B[i].a - vh * 0.5) act = i;
    for (const i of [6, 7]) { const el = this.q('[data-sec="' + i + '"]'); if (el && el.getBoundingClientRect().top < vh * 0.5) act = i; }
    if (act !== this.actDot) { this.actDot = act; (this.rootRef.current ? [...this.rootRef.current.querySelectorAll('[data-dot]')] : []).forEach((el) => { const on = +el.dataset.dot === act, d = el.firstElementChild; d.style.opacity = on ? '1' : '0.3'; d.style.transform = on ? 'scale(1.5)' : 'none'; }); (this.rootRef.current ? [...this.rootRef.current.querySelectorAll('[data-ol]')] : []).forEach((el) => { el.style.textDecoration = +el.dataset.ol === act ? 'underline' : 'none'; }); }
    if (narrow !== this.wasNarrow) {
      this.wasNarrow = narrow;
      const ht = this.q('[data-x=herotitle]'); if (ht) ht.style.maxWidth = narrow ? '88vw' : 'min(38vw,560px)';
      (this.trackRef.current ? [...this.trackRef.current.querySelectorAll('[data-fade]')] : []).forEach((el, i) => {
        if (!el.dataset.ji) el.dataset.ji = el.style.justifyContent + '|' + el.style.alignItems + '|' + el.style.padding;
        const [j, a, pd] = el.dataset.ji.split('|');
        if (narrow && i > 0) { el.style.justifyContent = 'center'; el.style.alignItems = 'flex-end'; el.style.padding = '0 6vw 6vh'; el.style.background = 'linear-gradient(to top, rgba(0,0,0,0.94) 0%, rgba(0,0,0,0.8) 34%, rgba(0,0,0,0) 70%)'; }
        else { el.style.justifyContent = j; el.style.alignItems = a; el.style.padding = pd; el.style.background = 'none'; }
      });
    }
  }

  renderVals() {
    const g = {}; for (let i = 0; i < 8; i++) { g['go' + i] = () => this.go(i); g['menu' + i] = () => { this.setMenu(false); this.go(i); }; }
    g.openMenu = () => this.setMenu(true); g.closeMenu = () => this.setMenu(false);
    return { rootRef: this.rootRef, trackRef: this.trackRef, hostRef: this.hostRef, ...g };
  }
}
const root = document.querySelector('[data-x-experience]');
if (root) {
  const app = new XAiOExperience();
  app.rootRef.current = root;
  app.trackRef.current = root.querySelector('[data-x-track]');
  app.hostRef.current = root.querySelector('[data-x-host]');
  app.resources = Object.fromEntries(
    Object.entries(JSON.parse(document.getElementById('x-aio-resources').textContent))
      .map(([key, value]) => [key, value.startsWith('//') ? 'https:' + value : value])
  );
  app.props = { rimTone: 'Neutral', blackness: 0.7, slimDepth: 10, glowStrength: 1, coilEffect: 'Thermal ramp', screenLogo: false };
  root.addEventListener('click', (event) => {
    const button = event.target.closest('[data-x-action]');
    if (!button || !root.contains(button)) return;
    const action = button.dataset.xAction;
    if (action === 'openMenu') app.setMenu(true);
    else if (action === 'closeMenu') app.setMenu(false);
    else if (/^(go|menu)[0-7]$/.test(action)) {
      if (action.startsWith('menu')) app.setMenu(false);
      app.go(Number(action.at(-1)));
    }
  });
  app.componentDidMount();
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.contains(root)) app.componentWillUnmount();
  });
}
